/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

/**
 * GetUserGlobalPrefCommand.js --
 *
 *      get user global preference.
 *
 */

import { globalArray } from "../jscdkClient";
import Logger from "../../../core/libs/logger";
import GetUserGlobalPrefHandler from "../controllers/getUserGlobalPrefHandler";

export default function GetUserGlobalPrefCommand() {}

GetUserGlobalPrefCommand.prototype.execute = function () {
   let getGlbUserPrefObj,
      handlerList,
      router = globalArray["router"];

   getGlbUserPrefObj = globalArray["get-user-global-preferences"];
   if (!getGlbUserPrefObj) {
      getGlbUserPrefObj = new GetUserGlobalPrefHandler();
      globalArray[getGlbUserPrefObj.messageName] = getGlbUserPrefObj;
      globalArray[getGlbUserPrefObj.responseTag] = getGlbUserPrefObj;
   } else {
      getGlbUserPrefObj.resetData();
   }

   if (!!getGlbUserPrefObj && !!router) {
      getGlbUserPrefObj.setRequestXML();
      handlerList = getGlbUserPrefObj.composeHandlerList();
      router.postMessage(handlerList);
   }
};
